import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createArticleCategory, getArticleCategoryById, getArticlesCategories, updateArticleCategory,
} from '../../axios/newsCategoriesRequests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  INewsCategoryStore,
} from '../storeInterfaces/newsCategoryInterface';
import { uploadSingleImage } from '../../helperFunctions/uploadService';
import { RequestStatus } from 'mobx-store';

export class NewsCategoryStore implements INewsCategoryStore {
  @observable categoriesList: any[] = [];

  @observable categoriesFilterList: any[] = [];

  @observable selectedCategory = {
  };

  @observable loading = false;

  @observable getNewsCategoriesRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getArticlesCategories(countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      this.getNewsCategoriesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);
      const params = {
        availableCountries,
      };
      const config = {
        ...getHeader(langCode), params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getArticlesCategories, config);
      this.categoriesList = this.restructureArticlesCategoriesList(response.data);
      this.categoriesFilterList = this.restructureArticlesCategoriesFilterList(response.data);
      this.getNewsCategoriesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getNewsCategoriesRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getArticleCategoryById(id: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getArticleCategoryById(id), getHeader(langCode));
      this.selectedCategory = this.restructureCategory(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createArticleCategory(countries: ICountry[], newArticle: any, langCode: string = DefaultLanguage): Promise<any> {
    return new Promise<void>(async (res, rej) => {
      try {
        let imageUrl = null;
        if (newArticle.imageUrl) {
          imageUrl = await uploadSingleImage(newArticle.imageUrl);
        }
        const availableCountries: any = [];
        availableCountries.push(convertCountriesToISOCodeString(countries));
        const categoryToCreate = {
          title: newArticle.title,
          imageUrl,
          availableCountries,
        };

        const response = await Connections.wadiDeglaAxios.httpPost(createArticleCategory, categoryToCreate, getHeader(langCode));
        res(response.data.articleCategoryId);
      } catch (error) {
        rej(error);
      }
    });
  }

  @action.bound
  public async updateArticleCategory(updatedCategory: any, categoryId: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      let imageUrl = null;
      if (updatedCategory.imageUrl) {
        imageUrl = await uploadSingleImage(updatedCategory.imageUrl);
      }
      const categoryToUpdate = {
        title: updatedCategory.title,
        imageUrl,
      };

      await Connections.wadiDeglaAxios.httpPut(updateArticleCategory(categoryId), categoryToUpdate, getHeader(langCode));
    } catch (error) {
      console.log(error);
    }
  }

  private restructureArticlesCategoriesList(categories: any[]): any[] {
    const CategoriesList = [];
    for (const category of categories) {
      CategoriesList.push({
        categoryId: category.articleCategoryId,
        title: category.title,
        imageUrl: category.imageUrl,
      });
    }
    return CategoriesList;
  }

  private restructureCategory(category: any): any {
    const restructuredCategory = {
      categoryId: category.articleCategoryId,
      title: category.title,
      imageUrl: (category.imageUrl ? [{
        imageUrl: category.imageUrl,
      }] : []),
    };
    return restructuredCategory;
  }

  private restructureArticlesCategoriesFilterList(categories: any[]): any[] {
    const CategoriesList = [];
    CategoriesList.push({
      categoryId: 0,
      title: 'All',
    });
    for (const category of categories) {
      CategoriesList.push({
        categoryId: category.articleCategoryId,
        title: category.title,
      });
    }
    return CategoriesList;
  }
}
